import React, { useCallback, useEffect, useMemo } from "react";
import {
   BrowserRouter as Router,
   Route,
   Switch,
   Redirect,
} from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { connect } from "react-redux";
import {
   faFilePdf,
   faTractor,
   faIdBadge,
   faTruck,
   faMapMarked,
   faCheckSquare,
   faFile,
   faDirections,
   faUserCog,
   faSignInAlt,
} from "@fortawesome/free-solid-svg-icons";

import routes from "../routes";
import Loading from "../components/Loading";
import AppContainer from "../containers/AppContainer";
import useStyles from "./styles";
import Terms from "../components/Terms";
import RouteProvider from '../context/router';
import { getUserSettings, getSchedulerConfigMenus } from "../configs/menuProfile";
import UnassignedView from "./Unassigned";

library.add(
   faFilePdf,
   faTractor,
   faIdBadge,
   faTruck,
   faMapMarked,
   faCheckSquare,
   faFile,
   faDirections,
   faUserCog,
   faSignInAlt
);

function App({
   authenticated,
   hasAcceptedTerms,
   mainGroup,
   mainGroups,
   getSettings,
   getConfigs,
   setBranches,
   setBranchRegions,
   setFarms,
   filteredBranchesString,
   setNotificationBranches,
   setTransporters,
   setTransportersBranches,
   filterStateTransporters,
   userId,
   loadSelected,
   userData
}) {
   const classes = useStyles();

   const appRoutes = useMemo(() => {
      if (!mainGroup) return [];
      const _menus = [...getUserSettings(mainGroup, mainGroups), ...getSchedulerConfigMenus(mainGroups).map(a => a[0])];
      const _appRoutes = [];
      routes.appRoutes.forEach(r => {
         _menus.forEach(m => m.subRoutes.forEach(s => {
            if (r.path === s.route) {
               _appRoutes.push(r);
            }
         }))
      });
      return _appRoutes;
   }, [mainGroup, mainGroups]);

   const loadSettings = useCallback(async () => {
     if (window.location.href.indexOf('access_code') !== -1) {
       let accesCode = window.location.href.split("access_code=");
       await getSettings(accesCode[1]);
     } else {
       await getSettings();
     }

     getConfigs();
   }, [getSettings, getConfigs]);

   useEffect(() => {
     loadSettings()

   }, [loadSettings]);

   useEffect(() => {
      setNotificationBranches(filteredBranchesString)
   }, [setNotificationBranches, filteredBranchesString]);

   useEffect(() => {
      const checkuser = async (group, groups) => {
         if (["backoffice", "support"].includes(group)) {
            if (groups.length === 1 && groups.includes('user')) return;
            await setBranches({ userId: userId });
            await setBranchRegions();
            await loadSelected();
        } else if (["farmer"].includes(group)) {
          await setFarms();
        } else if (["farm"].includes(group)) {
          const isMobile = window.matchMedia("(max-width: 768px)").matches;

          if (isMobile) {
            /**
             * @TODO - redirect do warehouse
             */
            if (window.origin === 'http://localhost:3000') {
              console.log('Volte para o peach e use esse token: ', userData.token);

              return window.location.replace('http://localhost:3002/new/tdms/farm/loading-orders/cbz');
            }

            let peachWarehouseUrl = window.origin + '/peach/new/tdms/farm/loading-orders/cbz';

            return window.location.replace(peachWarehouseUrl);
          }
        } else if (["warehouse"].includes(group)) {
          // await setBranches({ userId: userId, userGroup: "warehouse" });

          /**
           * @TODO - redirect do warehouse
           */
         if (window.origin === 'http://localhost:3000') {
            console.log('Volte para o peach e use esse token: ', userData.token);

            return window.location.replace('http://localhost:3002/new/tdms/warehouse/loading-orders');
          }

          let peachWarehouseUrl = window.origin + '/peach/new/tdms/warehouse/loading-orders';

          return window.location.replace(peachWarehouseUrl);
        } else if (["certifier"].includes(group)) {
         /**
          * @TODO - redirect do certifier
          */
         if (window.origin === 'http://localhost:3000') {
            console.log('Volte para o peach e use esse token: ', userData.token);

            return window.location.replace('http://localhost:3002');
          }

          let peachLoadingOrderValidationUrl = window.origin + '/peach/new/tdms/loading-orders/validation';

          return window.location.replace(peachLoadingOrderValidationUrl);
        }
        if (["transporter"].includes(group)) {
          await setTransporters({ userId: userId, managerId: "" });
        }
      };
      checkuser(mainGroup, mainGroups);
   }, [mainGroup, mainGroups, setBranches, setBranchRegions, setFarms, loadSelected, userId, setTransportersBranches, setTransporters, userData.token]);

   useEffect(() => {
    if (Array.isArray(filterStateTransporters) && filterStateTransporters.length) {
      setTransportersBranches(filterStateTransporters.map((i) => i && i.value).join());
    }
   }, [filterStateTransporters, setTransportersBranches])

   return (
      // eslint-disable-next-line
      <>
         {authenticated ? (
            hasAcceptedTerms ? (
               <Router>
                  <AppContainer>

                     <RouteProvider>
                        <Switch>
                           <Route path="/unassigned" component={UnassignedView} />
                           {
                              appRoutes.map( (r, index) => {
                                 return (
                                 <Route {...r} key={index} />
                              )})
                           }
                           <Redirect from="/" to={routes.root(mainGroup, mainGroups)} />
                        </Switch>
                     </RouteProvider>
                  </AppContainer>
               </Router>
            ) : (
                  <div className={classes.waitingContent}>
                     <Terms />
                  </div>
               )
         ) : (
               <Loading />
            )}
      </>
   );
}

const mapState = ({ auth: { user }, branches, transporters }) => {
   return {
      userData: user,
      authenticated: !!user.name,
      userId: user.id,
      mainGroup: user.mainGroup,
      mainGroups: user.groups,
      hasAcceptedTerms:
         !["farmer", "driver"].includes(user.mainGroup) || user.hasAcceptedTerms,
      filteredBranchesString: branches.filteredBranchString,
      filteredTransportersString: transporters.filteredTransportersString,
      filterStateTransporters: transporters.filterState,
   };
};

const mapDispatch = (dispatch) => ({
   getSettings: (payload) => dispatch.auth.getSettingsAsync(payload),
   getConfigs: () => dispatch.configs.loadConfigsAsync(),
   setBranches: (payload) => dispatch.branches.setBranchesAsync(payload),
   setBranchRegions: (payload) => dispatch.branches.setBranchRegionsAsync(payload),
   setTransporters: (payload) => dispatch.users.getTransportersAsync(payload),
   setTransportersBranches: (payload) => dispatch.branches.setTransportersBranchesAsync(payload),
   setFarms: (payload) => dispatch.farms.setFarmsAsync(payload),
   loadSelected: () => dispatch.loadingOrders.loadSelected(),
   setNotificationBranches: (payload) => dispatch.notifications.setBranchIdsAsync(payload),
});

export default connect(mapState, mapDispatch)(App);
